'use client';

import React, { useContext } from 'react';
import { LeftNavItem } from '@/_components';
import { DocumentsContext } from '@/_contexts/DocumentsProvider';
import type { FileItemProps } from './FileItem.types';
import { getFileItemPath, getDocumentIcon } from '@/_utils/documents';
import { IconType } from '@/_types/icons';
import { DirectoryType } from '@/_types/models/documents';

export const FileItem: React.FC<FileItemProps> = ({ item }) => {
  const { openDirectory, onToggleDirectory } = useContext(DocumentsContext);
  const realPath = getFileItemPath(item.link);

  if (!item) return null;

  const isOpen: boolean = realPath === openDirectory;
  const icon: IconType = getDocumentIcon(item, isOpen);

  const onDirToggle = () => {
    onToggleDirectory(item as DirectoryType, realPath);
  };

  return (
    <div onClick={onDirToggle}>
      <LeftNavItem name={item.name} isActive={isOpen} icon={icon} />
    </div>
  );
};
